<script setup>
import MWIRegisterForm from "@/components/mwi/MWIRegisterForm.vue"
</script>

<template>
  <MWIRegisterForm />
</template>
